"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceCXIdMappingClientProvider = exports.MarketplaceCXIdMappingContext = void 0;
var MarketplaceCXIdMappingContext_1 = require("./MarketplaceCXIdMappingContext");
Object.defineProperty(exports, "MarketplaceCXIdMappingContext", { enumerable: true, get: function () { return __importDefault(MarketplaceCXIdMappingContext_1).default; } });
var MarketplaceCXIdMappingClientProvider_1 = require("./MarketplaceCXIdMappingClientProvider");
Object.defineProperty(exports, "MarketplaceCXIdMappingClientProvider", { enumerable: true, get: function () { return __importDefault(MarketplaceCXIdMappingClientProvider_1).default; } });
